// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3kD04","inputWrap":"Table_inputWrap__18G8u","col":"Table_col__27uY3","bmiTooltip":"Table_bmiTooltip__2ZEQ3"};